const DURATION_MS = 2000;

export function initPromiseStatsBlocks() {
	const blocks = document.querySelectorAll('[data-promise-stats]');
	if (!blocks.length) {
		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				const block = entry.target;
				animateCounters(block);
				observer.unobserve(block);
			});
		},
		{ threshold: 0.35 }
	);

	blocks.forEach((block) => {
		observer.observe(block);
	});
}

function animateCounters(block) {
	const counters = block.querySelectorAll('[data-counter]');
	counters.forEach((counter) => {
		const raw = counter.getAttribute('data-counter-text') || counter.textContent || '';
		const parsed = parseCounterText(raw);
		if (!parsed) {
			return;
		}

		const start = performance.now();
		const { prefix, suffix, target, decimals } = parsed;

		const tick = (now) => {
			const elapsed = now - start;
			const progress = Math.min(1, elapsed / DURATION_MS);
			const eased = 1 - Math.pow(1 - progress, 3);
			const current = target * eased;

			const rounded = decimals > 0 ? current.toFixed(decimals) : String(Math.floor(current));
			counter.textContent = `${prefix}${rounded}${suffix}`;

			if (progress < 1) {
				requestAnimationFrame(tick);
				return;
			}

			counter.textContent = raw;
		};

		requestAnimationFrame(tick);
	});
}

function parseCounterText(value) {
	const text = String(value).trim();
	if (!text) {
		return null;
	}

	const match = text.match(/-?\d+(?:[.,]\d+)?/);
	if (!match || typeof match.index !== 'number') {
		return null;
	}

	const numberRaw = match[0];
	const target = Number.parseFloat(numberRaw.replace(',', '.'));
	if (!Number.isFinite(target)) {
		return null;
	}

	const decimalsMatch = numberRaw.match(/[.,](\d+)$/);
	const decimals = decimalsMatch ? decimalsMatch[1].length : 0;

	return {
		prefix: text.slice(0, match.index),
		suffix: text.slice(match.index + numberRaw.length),
		target,
		decimals,
	};
}
